export const locale = {
  WEEKDAYS: {
    MONDAY: "Monday",
    TUESDAY: "Tuesday",
    WEDNESDAY: "Wednesday",
    THURSDAY: "Thursday",
    FRIDAY: "Friday",
    SATURDAY: "Saturday",
    SUNDAY: "Sunday",
  },
  COMMON: {
    LBL_AGENT: "GBizs Agent",
    LBL_MOBILE_CONTACT_NO: "Mobile Contact No.",
    LBL_MOBILE_CONTTACT_PIC: "Mobile Contact Pic",
    LBL_ALT_MOBILE_CONTACT_NO: "Mobile Contact No. (Alt)",
    LBL_ALT_MOBILE_CONTTACT_PIC: "Mobile Contact Pic (Alt)",
    LBL_STATUS: "Status",
    LBL_REQUIRE_LOGIN: "Require Login",
    LBL_OFFICE_NO: "Office No. ",
    LBL_OFFICE_NO_PIC: "Office No. PIC",
    LBL_SET_INVALID_PERSONNEL: "Invalid By",
    LBL_APPROVED_BY: "Approved By",
    LBL_REJECTED_BY: "Rejected By",
    LBL_REVERTED_BY: "Reverted By",
    LBL_ACKNOWLEDGE_BY: "Acknowledge By",
    LBL_VERIFY_BY: "Verify By",
    LBL_ACTION_TIME: "Action Time",
    LBL_REFERENCE_NO: "Ref. No.",
    LBL_HISTORY_DATE: "Modified Date",
    LBL_PARCEL_GUARANTEE: "Parcel Guarantee",
    LBL_REMARK: "Remark",
    LBL_ACTION: "Action",
    LBL_AR_REMARK: "AR Remark",
    LBL_AP_REMARK: "AP Remark",
    LBL_RECEIVED_AMOUNT: "Received Amt",
    LBL_RECEIVED_DATE: "Received Date",
    LBL_MARKING: "Marking",
    LBL_SO_NO: "S/O No.",
    LBL_NOTICE_TYPE: "Notice Type",
    LBL_USE_DO_HEADER: "Use Do Header",
    LBL_DO_HEADER: "DO Header",
    LBL_EMAIL: "Email",
    LBL_TIN_NO: "Tin No.",
    LBL_ENABLE_SST: "Enable SST",
    LBL_ENABLE_EINV: "Enable E-Invoice",
    LBL_EINV_EN_DATE: "E-Invoice Enable Date",
    LBL_EINV_MISC_CODE: "E-Invoice MSIC Code",
    LBL_EINV_MISC_DESC: "E-Invoice MSIC Desc",
    LBL_CATEGORY_TYPE: "Category Type",
    LBL_SHIPMENT_TYPE: "Shipment Type",
    LBL_SHIPMENT_MODE: "Shipment Mode",
    LBL_NONE: "None",
    LBL_LENGTH: "Length",
    LBL_WIDTH: "Width",
    LBL_HEIGHT: "Height",
    LBL_FULL_MARKING: "Full Marking",
    LBL_CONTACT: "Contact",
    LBL_MOBILE: "Mobile",

    LBL_FAX_NO: "Fax No.",
    LBL_FAX_NO_PIC: "Fax No. PIC",
    LBL_SERIAL_NO: "No.",
    LBL_DELIVERY_ID: "Del. ID",
    LBL_TOTAL: "Total",
    LBL_ACTUAL_SO_NO: "Actual S/O No.",
    LBL_COUNTRY: "Country",
    LBL_CODE: "Code",
    LBL_NAME: "Name",
    LBL_DESCRIPTION: "Description",
    LBL_REF_ID: "Ref Id",
    LBL_LOADED_DATE: "Loaded Date",
    LBL_ORDER_DATE: "Order Date",
    LBL_SUPPLIER: "Supplier",
    LBL_CREATED_ON: "Created On",
    LBL_AUTO_SAVE: "Auto Save",
    LBL_VERSION_NO: "Version No.",
    LBL_DO_NO: "D/O No.",
    LBL_SST_NO: "SST No.",
    LBL_SHOW_DETAIL: "Show Detail",
    LBL_FILTER: "Filter By",
    LBL_AUTO_GENERATE: "Auto Generate",
    LBL_ROW_ID: "Row Id",
    LBL_DOC_DATE: "Doc Date",
    LBL_USER: "User",
    LBL_EXP: "EXP",
    LBL_COPY_AS_NEW: "Copy As New",

    LBL_CTN: "CTN",
    LBL_KG: "KG",
    LBL_M3: "M3",
    LBL_AMOUNT: "Amount",
    LBL_TTL_CTN: "Ttl CTN",
    LBL_SO_RCV: "S/O Receive",
    LBL_DATE: "Date",
    LBL_LOADING_STATUS: "Loading Status",
    LBL_DUE_DAYS: "Due Day(s)",
    LBL_PAYMENT_TYPE: "Payment Type",
    LBL_BILL_ADDRESS: "Billing Address",
    LBL_SET_TO_EXPIRE: "Set To Expire",
    LBL_API_CLIENT_ID: "Client Id",
    LBL_API_CLIENT_KEY: "Client Key",
    LBL_SYS_NOTIFY_VIA_EMAIL: "Notify Via Email",
    LBL_SYS_NOTIFY_INBOX: "Notify Via System Inbox",
    LBL_EXPIRED: "Expired",
    LBL_AGENT_MARKING: "Agent Marking",
    LBL_CUSTOMER: "Customer",
    LBL_REGISTER_NO: "Register No.",
    LBL_REGISTER_NO_NRIC: "Register No/Nric",
    LBL_SUMMARY_OPTIONS: "Summary Options",
    LBL_SCS_REMARK: "SCS Remark",
    LBL_REASON: "Reason",
    LBL_REASON_REMARK: "Reason Remark",
    LBL_EQN_NO: "Enquiry No",

    ADDRESS: {
      LBL_BUILDING_NAME: "Building Name",
      LBL_UPSTAIRS: "Move Upstairs?",
      LBL_FULL_ADDRESS: "Full Address",
      LBL_FULL_ADDRESS_SHORT: "Full Addr.",
    },

    FORM_EMAIL_DESC: "For Example: example@gmail.com;example1@gmail.com",

    TXT_ALL: "All",
    TOTAL_TITLE: "Total",
    TXT_RANGE: "Between {from} - {to}",
    TXT_ABV: ">= {from}",
    TXT_BELOW: "<= {to}",

    SELECTION_OTHERS: "Other",
    PH_ENTER_TEXTBOX: "Enter {txt_fieldname}",
    PH_ENTER_DATE: "Enter Date",
    PH_ENTER_DATE_FROM: "Enter {name} From",
    PH_ENTER_DATE_TO: "Enter {name} To",
    PHP_ENTER_SEARCH: "Enter {name} To Search",
    MSG_SUPPORT_IMAGE_SIZE_FORMAT:
      "Supported size should be less than 1 MB and Supported Format .jpg, .jpeg, .png",
    MSG_IMAGE_FORMAT_NOT_SUPPORTED:
      "Image format not supported. Supported format: .jpg, .jpeg, .png",
    MSG_SUPPORT_DOC_SIZE_FORMAT:
      "Supported Document size should be less than 10 MB",
    MSG_PROGRESS: "Please wait a moment ... ....",
    MSG_SUPPORT_EXCEL_FILE: "Supported File Type: .xlsx, .xls",
    MSG_ROW_ERROR: "Row: {idx}",
    MSG_COPY_FAILED: "Failed to copy {name}",
    MSG_COPIED_TO_CLIPBOARD: "Copied to clipboard",

    STATUS: {
      INACTIVE: "Inactive",
      ACTIVE: "Active",
      SUSPEND: "Suspend",
      UNVERIFIED: "Un-verify",
      YES: "Yes",
      WGI: "WGI",
      NO: "No",
      REQUIRED: "Required",
      OPTIONAL: "Optional",
      DRAFT: "Save As Draft",
      PENDING: "Pending",
      APPROVED: "Approved",
      REJECTED: "Rejected",
      VERIFY: "Verifying",
      CLOSED: "Closed",
      OPEN: "Open",
      ACKNOWLEDGE: "Acknowledge",
      NEW: "New",
      EXPIRE: "Expired",
      VALID: "Valid",
      LOCKED: "Locked",
      REJECT: "Reject",
      REVERT: "Revert",
      VERIFIED: "Verified",
      BLOCKED: "Blocked",
      SUSTAINED_EFFECTIVE: "Sustained Effectiveness",
      CONFIRM: "Confirmed",
      RECEIVE_GOODS: "Received",
      PENDING_ACKNOWLEDGE: "Pending Acknowledge",
      ACKNOWLEDGED: "Acknowledged",
      REQUEST_REVERT: "Request Revert",
      REVERTED: "Reverted",
      DONE: "Done",
      EXISTS: "Exists",
    },

    MSG: {
      API_SERVER_DOWN:
        "Server Connection Refused. Please contact System Admin.",
      MSG_DATA_NOT_FOUND: "No Records Found",
      DATA_NOT_AVAILABLE: "No Data Available",
      SUCCESSFUL_IMPORT_EXCEL: "Import excel successfully",
      API_SERVER_DOWN_WITH_NAME:
        "{name} Server Connection Refused, Please Contact System Admin",
      AGENT_PATH_MISSING: "{name} route not set",
      VERSION_NOT_MATCH: "The data has been modified, please reload.",
      NETWORK_ERR: "Unstable Network Connection",
      NETWORK_MESS:
        "We're detecting a network error. Please ensure you have a stable internet connection and try again.",
      TIMEOUT_ERROR: "Session Timeout",
      TIMEOUT_MESS: "Your session has timed out. Please log in again",
      CONFIRM_RESET: "Entered data will be reset. Are you sure to continue?",
      DOC_FILE_SIZE: "The permissible file size must not exceed {size} MB.",
      SUCCESSFULL_DOWNLOAD_FILE:
        'The file has downloaded successfully.  Please examine your device\'s "Downloads" folder or the designated save location.',
      ERROR_SEARCH_FAILED:
        "Search Api failed call, Please contact System Admin.",
      SUPPORT_ASCII:
        "{name} only supported alphabet letters, numbers and standard symbols.",
      FAILED_TO_GENERATE_PDF: "Failed to generate PDF: {error}",
      FAILED_TO_SAVE: "Failed To Save",
      API_CALLS_FAILED: "1 or more Api Calls faield: {error}",
    },

    VALIDATION: {
      INVALID: "{name} is not valid",
      REQUIRED: "{name} is required",
      REQUIRED_GREATER_ZERO: "{name} must be greater than zero",
      MIN_LENGTH: "{name} minimum length is {min}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {name} is not found",
      REF_NOT_FOUND: "Ref/Doc No.: {ref_no} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid",
      NUMBER: "{name} must be number",
      CANNOT_EQUAL: "{p1} cannot be the same as {p2}",
      EXPIRE: "{name} must be greater than current date",

      MISSING_REQ_DATA: "Please fill in all details",
      INVALID_WARNING_MSG: "Please, provide correct data!",
      DUPLICATE_ENTRY: "{name} is duplicate.",
      UNIQUE_FIELD: "{name} must be unique.",
      REF_NO_DUPLICATE: "{name}: {ref_no} is duplicate",
      DOCUMENT_NUMBERING_NOT_SET:
        "Document Number Format is not found. Please setup first.",
      DOC_NUMBER_NOT_SET_TYPE:
        "{doc_type} Document Number Format is not found. Please contact the system administrator.",
      ID_NOT_FOUND: "Record not found",
      RECORD_NOT_FOUND: "Record not found",
      MISSING_DOC_TYPE:
        "Doc Type: {doc_type} not found. Please Contact System Admin.",
      UNIQUE_VALUE: "{code} is not available",
      STATE_CODE_REQUIRED: "State code is not set",
      MARKING_NOT_EXISTS: "Marking not exists",
      DOCUMENT_NO_DUPLICATE:
        "Document Number is duplicate. Please try save again.",
      DOCUMENT_NO_type_DUPLICATE:
        "Document Number is duplicate ({doc_type}). Please try again.",
      DATE_FROM_GREATER_THAN_DATE_TO:
        "{date_to} must be greater than {date_from}",
      AMOUNT_GREATER_THAN: "{name} must be greater than {field}",
      DATA_NOT_FOUND_REQ_CREATE:
        "{code} unable to found. Please create a new record",
      DATA_NOT_FOUND: "{data} record not found",

      INVALID_CONTACT_NO_FORMAT: {
        FORMAT_MY: "{name} is not valid, correct format eg: 123456789",
      },
      POSITIVE: "{name} only allow enter positive number",
      RECORD_NO_SELECTED: "No record has been selected",
      INVALID_DATE_FORMAT_EXCEL: "{name} date format not supported",
      ROW_DATA_NOT_FOUND: "Row: {idx} data not found",
      DUPLICATE_RECORD_SET: "Duplicate Set",
      DOCUMENT_FORMAT_LENGHT: "No. Format cannot more than {len} character",
      DOCUMNET_NUMBER_FORMAT_DUPLICATE_SET: "No.Format: {format} duplicate set",
      EXCEL_FILE_NOT_UPLOAD: "Please upload product excel file",
      EXCEL_FILE_TYPE_INVALID: "Excel File Type Invalid",
      EXCEL_IMPORT_DATA_NOT_FOUND: "Uploaded Data not found",
      EXCEL_DATA_INCORRECT: "Please ensure uploaded data is correct",
      CURRENCY_RATE_NOT_SET: "Daily rate is not set",
      CURRENCY_RATE_DEFAULT_NOT_SET:
        "{currency} conversion setting not set. Please contact Person In Charges",
      IS_EMPTY: "{name} is empty.",
      DUPLICATE_TBL_ROW: "{name} is duplicated with row {index}",
      FILE_TYPE_INVALID: "{name} File Type Invalid",
      FILE_SIZE_EXCEEDED: "File size too large. Maximum size: {file_size} MB",
      EXCEL_SHEET_NOT_FOUND: "{name} Sheet not found in excel file",
      EXCEL_FILE_RECORD_NOT_FOUND:
        "The imported Excel file contains no records.",
      EXCEL_COLUMN_REQUIRED: "Row: {index}, {colname} is required. <br />",
      EXCEL_COLUMN_VALUE_GREATER_THAN_ZERO:
        "Row: {index}, {colname} must be greater than 0.",
      ASCII_KEY_CODE:
        "** ITEM CODE contains unsupported characters. Please use only English letters and numbers.",
      ASCII_INVALID:
        "{name} contains unsupported characters. Only supported alphabet letters, numbers and standard symbols.",
      MAX_LEN_FIELD: "{name} maximum length is {len}",
      MODULE_ID_REQUIRED: "{mod} module id is required",
      NO_DATA_TO_EXPORT: "No data export to excel",
    },

    BTN_DOWNLOAD_ALL_AS_PDF: "Download All As PDF",
    BTN_DOWNLOAD_AS_PDF: "Download As PDF",
    BTN_REJECT: "Reject",
    BTN_VERIFY: "Verify",
    BTN_SEARCH: "Search",
    BTN_CLEAR: "Clear",
    BTN_CLEAR_FORMAT: "Clear Format",
    BTN_CANCEL: "Cancel",
    BTN_BACK: "Back",
    BTN_SAVE: "Save",
    BTN_BROWSE: "Browse",
    BTN_EDIT: "Edit",
    BTN_REVERT: "Revert",
    BTN_CREATE: "Create New {btn_name}",
    BTN_SUBMIT: "Submit",
    BTN_APPROVE: "Approve",
    BTN_ADD: "Add",
    BTN_DELETE: "Delete",
    BTN_COPY: "Copy",
    BTN_CLOSE: "Close",
    BTN_OPEN: "Open",
    BTN_CONFIRM: "Confirm",
    BTN_ACKNOWLEDGE: "Acknowledge",
    BTN_PREVIEW: "Preview",
    BTN_SAVE_AS_DRAFT: "Save As Draft",
    BTN_PRINT: "Print",
    BTN_PRINT_ALL: "Print All",
    BTN_CONFIRM_N_APPROVE: "Confirm & Approve",
    BTN_VIEW: "View",
    BTN_RESET: "Reset",
    BTN_DOWNLOAD_ALL: "Download All",
    BTN_DOWNLOAD_SELECTED: "Download Selected",
    BTN_COST_SETUP: "Cost Setup",
    BTN_LEAVE: "Leave Page",
    BTN_STAY: "Stay on the page",
    BTN_REFRESH: "Refresh",
    BTN_OK: "Ok",
    BTN_UPLOAD: "upload",
    BTN_IMPORT: "Import Excel",
    BTN_POST: "Post",
    BTN_REVERSE: "Reverse",
    BTN_SYNC_ALL: "Sync All",
    BTN_SYNC_ALL_WAREHOUSE: "Sync All To Warehouse",
    BTN_SYNC_ALL_AGENT: "Sync All To Agent",
    BTN_PREVIEW_IMAGE: "Preview Image",
    BTN_PREVIEW_DOC: "Preview Document",
    BTN_UPLOAD_IMAGE: "Upload Image",
    BTN_UPLOAD_DOC: "Upload Supported Document",
    BTN_ALL: "All",
    BTN_HISTORY: "History",
    BTN_SYNC_TO_AGENT: "Sync To Agent",
    BTN_SYNC_TO_WAREHOUSE: "Sync To Warehouse",
    BTN_POST_TO_ACCOUNT: "Post To Account",
    BTN_NEW: "New",
    BTN_SKIP: "Skip",
    BTN_ENABLE_EDIT: "Enable Edit",
    BTN_DISABLE_EDIT: "Disable Edit",
    BTN_COPY_EDIT: "Copy/Edit",
    BTN_IGNORE: "Ignore",
    BTN_SELECT: "Select",
    BTN_LINK: "Link",
    BTN_REMOVE: "Remove",
    BTN_DROP_FILE: "Click or Drag {file} file to this area to upload",
    BTN_DROP_FILE_SIMPLE: "Click or Drag {file}",
    BTN_CLICK_HERE: "Click Here",
    BTN_ADD_FROM_SO_RECEIVED: "Add from S/O Received",
    BTN_YES: "Yes",
    BTN_NO: "No",
    BTN_REMOVE_SORT: "Remove Sorting",
    BTN_ADD_NEW_ROW: "Add New {name}",
    BTN_ADD_NEW: "Add New",

    BTN_ENABLED: "Enable Edit {name}",
    BTN_DISABLE: "Disable Edit {name}",
    BTN_EXPORT_EXCEL: "Export To Excel",
    BTN_COLLPASE_ALL: "Collapse All",
    BTN_EXPAND_ALL: "Expand All",
    BTN_SAVE_AND_COPY: "Save & Copy",
    BTN_SAVE_AND_NEW: "Save & New",

    BTN_MANUAL: "Manual",
    BTN_AUTO: "Auto",
    BTN_LOGIN: "Sign In",
    BTN_EXPORT_TO_EXCEL: "Export To Excel",
    BTN_APPLY: "Apply",
    BTN_DELETE_ALL: "Delete All",
    BTN_SEND_EMAIL: "Send Email",
    BTN_ISSUE: "Issue",
    BTN_ISSUE_EMAIL: "Issue & Email",
    BTN_DEL_ROW: "Delete {name}",
    BTN_PREVIOUS: "Prev",
    BTN_NEXT: "Next",
    BTN_AR_REJECT: "AR Reject",
    BTN_ADD_FROM: "Add From {name}",

    FILE_TYPE: {
      EXCEL: "Excel",
      PDF: "PDF",
      IMAGE: "Image (s)",
    },

    COL_RECEIVED_QUANTITY: "Rcv. Qty",
    COL_RECEIVED_AMOUNT: "Rcv. Amt.",
    COL_RECEIVED_DATE: "Rcv. Date",
    COL_CODE: "Code",
    COL_NAME: "Name",
    COL_EMAIL: "Email",
    COL_SHIPMENT_TYPE: "Shipt. Type",
    COL_COUNTRY: "Country",
    COL_CREATED_ON: "Created On",
    COL_WAREHOUSE: "WH",
    COL_EXPIRED_DATE: "Expired Date",
    COL_LOADED_DATE: "Loaded Date",
    COL_COMPANY_SUB_GRP: "Comp Sub Grp.",
    COL_MSM: "Msm",
    COL_SM: "Sm",
    COL_MODIFIEDBY: "Modified By",
    COL_CREATEDBY: "Created By",
    COL_DELIVERY_ZONE: "Del. Zone",
    COL_DISCOUNT_AMOUNT: "Disc Amt",

    USER_TYPE: {
      INTERNAL_STAFF: "Internal Staff",
      MAIN_SALESMAN: "Main Salesman",
      SALESMAN: "Salesman",
      SYSTEM_ADMIN: "System Admin",
      WAREHOUSE_STAFF: "Warehouse/Office Staff",
      AGENT_STAFF: "Agent Staff",
    },

    TITLE: {
      SUMMARY: "{name} Listing",
      CREATE: "Create New {name}",
      DETAIL: "{name} Detail",
      EDIT: "Edit {name}",
      INQUIRY: "Inquiry {name}",
      SCS_CONFIRM: "Scs Confirm {name}",
      SCS_APPROVE: "Scs Approve {name}",
    },

    TITLE_DETAILS: "Details",
    TITLE_SUMMARY: "Summary",
    TITLE_RESHIP_ITEM: "Reship Item",
    TITLE_EXCLUDE_SHIP: "Exclude Ship",
    TITLE_SELECT: "Select {mod}",

    TRANS_TYPE: {
      COURIER: "Courier",
      LOGISTIC: "Logistic",
    },

    RICH_TEXT_EDITOR_HEAD: {
      NORMAL_TEXT: "Normal Text",
      HEADING_ONE: "Heading 1",
      HEADING_TWO: "Heading 2",
      HEADING_THREE: "Heading 3",
      HEADING_FOUR: "Heading 4",
      HEADING_FIVE: "Heading 5",
      HEADING_SIX: "Heading 6",
    },

    RICH_TEXT_EDITOR_WORD:
      "Word Count: {word_count} | Character Count: {character_count}",

    DOCUMENT_LANGUAGE_SELECTION: {
      CN: "Chinese",
      EN: "English",
      TH: "Thai",
    },

    GRN_FORMAT: {
      DEFAULT: "Default",
      DUO_LANGUAGE: "Dual Language",
    },

    PAYMENT: {
      OUTSTANDING: "OutStanding",
      FULLY_PAID: "Fully Paid",
      CLOSED_ORDER: "Closed Order",
      FULLY_CANCELLED: "Fully Cancelled",
    },
  },
  MENU: {
    ASIDE: {
      CATEGORY_PARENT: "Product Category (Parent)",
      CATEGORY: "Product Category (Lvl 2)",
      MISSING_STATUS_INQUIRY: "Assign Missing S/O",

      USER: "User",
      ROLE: "Role",
      DATA_FILTER: "Data Filter",
      USER_N_ROLE_MANAGEMENT: "User & Role Management",
      USER_GROUP: "User Group",
      SHIPMENT: "Shipment",
      SHIPMENT_TYPE: "Shipment Type",
      SHIPMENT_MODE: "Shipment Mode",
      COURIER_COMPANY: "Courier Company",
      DELIVERY_AGENT: "Courier Agent",
      LANGUAGE: "Language",
      CONSIGNMENT_SO: "Consignment S/O",
      EPO_MANAGEMENT: "EPO Management",
      PACKING_TYPE: "Packing Type",
      PRODUCT_MANAGEMENT: "Product Management",
      SETTINGS: "Settings Management",
      SYSTEM_SETTINGS: "System Settings",
      TRANSACTION_SETTINGS: "Transaction Settings",
      GENERAL_SETTINGS: "General Settings",
      AGENT: "Agent",
      WAREHOUSE_SETTINGS: "Warehouse Settings",
    },
    HEADER: {
      TUTORIAL: "Tutorial",
      TUTORIAL_EN: "English Version",
      TUTORIAL_CN: "Chinese Version",
    },
  },
  AUTH: {
    BTN_SIGN_OUT: "Sign Out",
    USERNAME_TITLE: "Hi, {username}",
    FORGOT_PASSWORD: {
      MSG_RESET_PASSWORD_MESSAGE_DELIVERED:
        "Email has been dispatched to your inbox. If you don't find it in your inbox, please check your spam or junk folder, as it might have been filtered there.",
      TITLE: "Forgot Password",
      DESC: "Enter your email to reset your password",
      SUCCESS:
        "Password reset successful! You can now log in with your new credentials.",
      FAILED:
        "We couldn't send the password reset email to your address. Possible reasons:<br />1. The email isn't registered or has typos<br />2. It might be in your spam folder<br />3. System delay (please retry in 5 mins).",
    },
    RESET_PASS: {
      RESET_PASS_TITLE: "Reset your Password",
      RESET_PASS_DESC: "Change your new password",
      PASS: "New Password",
      COMFIRM_PASS: "Confirm Password",
      TOKEN_EXPIRED: "The token was expired",
      PASS_REQUIRED: "Password is required",
      COM_PASS_REQUIRED: "Confirm password is required",
      PASS_COM_NOT_SAME: "The password and confirm password are not the same",
      UPDATE_SUCCESS:
        "Password reset successful! You can now log in with your new credentials.",
      PROVIDE_CORRECT_DATA: "Please, provide correct data!",
    },
    PASSWORD: {
      PASSWORD_LENGTH: "Password must be 8 to 12 character",
      CONTAIN_AT_LEAST_LOWER_CASE: "At Least 1 Lower Case",
      CONTAIN_AT_LEAST_UPPER_CASE: "At Least 1 Upper Case",
      CONTAIN_AT_LEAST_ONE_DIGIT: "At Least 1 digit",
      CONTAIN_AT_LEAST_SPECIAL_CHARACTER:
        "At Least 1 special character(#?!@$%^&*-)",
      PASSWORD_REQUIREDMENT_TITLE: "Password Requirement: ",
    },
    RESPONSE_MSG: {
      ACCOUNT_STATUS_INVALID: "Login Account was inactive/deleted.",
    },
    APIAUTH: {
      RESET_API_CREDENTIAL: "Reset Api Credential",
      MSG_SUCCESSFUL_UPDATE: "Api Credential Successful updated",
      MSG_FAILED_UPDATE: "Api Credential Failed updated",
    },
  },
  EPO: {
    FORMAT_CN: "Chinese Format",
    FORMAT_EN: "English Format",
    FORMAT_IN: "Indonesian Format",
    FORMAT_TH: "Thai Format",
    FORMAT_VN: "Vietnamese Format",

    VIEW_PRODUCT_DETAIL: "Epo No.: {epo_no} Courier / Product Detail (s)",

    DOWNLOAD_EPO_IMPORT_EXCEL_FORMAT: "Download Import Product Excel Format",
    BTN_IMPORT_PROD: "Import Product",
    BTN_PRODUCT: "View Product",
    UPLOAD_RPODUCT_TITLE: "Import Product Excel File",

    MSG: {
      EXCEL_SHEET_NOT_FOUND: "{name} Sheet not found in excel file",
      EXCEL_FORMAT_NOT_FOUND: "{name} Sheet Column not matching!",
      EXCEL_DATA_EMPTY: "{name} Sheet no data set",
      PARCEL_GUARANTEE_ADD_CHARGES_CUSTOMER:
        "Additional Parcel Guarantee charges will apply. Please contact to person in charges.",
      PARCEL_GUARANTEE_ADD_CHARGES_ADMIN:
        "Additional Parcel Guarantee charges will apply. Please confirm with customer",
      PARCEL_GUARANTEE_CONFIRMATION:
        "Additional Parcel Guarantee charges will apply. Are you sure to continue?",
      CONSIGNMENT_NO_DUPLICATE_EPO:
        "Consignment No: {ref_no} duplicate with other EPO.",
      ERROR_SEARCH_FAILED:
        "Search Api failed call, Please contact System Admin.",
      ITEM_CODE_ERROR:
        "ITEM CODE must contain only English letters, numbers, and standard symbols, and must not exceed 20 characters.",
      CONFIRM_UPDATE_WAREHOUSE_DETAIL: "Update warehouse address and contact.",
    },

    BTN_ADD_PROD: "Add Product",
    BTN_UPD_EPO: "Modify Epo Header Detail",

    LBL_HAS_TAX_REBATE: "Tax Rebate",
    LBL_EPO_TYPE: "Epo Type",
    LBL_CONSIGNMENT_NO: "Consignment No.",
    COL_CONSIGNMENT_ARRIVED_WAREHOUSE: "Consignment RCV",
    LBL_INC_RCV: "Incl. Arrived Warehouse",

    EPO_TYPE: {
      ORDER: "Order",
      COURIER: "Courier",
    },

    TITLE_UPD_EPO: "Modify Epo Header Detail",
  },
  CUSTOMER: {
    REQUEST_TYPE: {
      CREATE_TYPE: "Create New",
      UPDATE_TYPE: "Update",
    },
    STATUS: {
      PENDING: "Pending",
      VERIFYING: "Verifying",
      APPROVED: "Approved",
      REJECTED: "Rejected",
    },
    LBL_SAVE_DELIVERY_ADDRESS: "Save As Delivery Address",
  },
  TT: {
    BENE_MODEL: {
      BENE_TITLE: "Beneficiary Details",
      INTERMEDIATE_TITLE: "Intermediate Bank Details",
      INTERMEDIATE_CHECKBOX: "Intermediate Bank?",
      ACC_HOLDER: "Account Holder",
      ACC_NO: "Account Number",
      BENE_CONTACT_PIC: "Bene Contact PIC",
      BENE_CONTACT_CALLING_CODE: "Bene Calling Code",
      BENE_CONTACT_NO: "Bene Contact Number",
      RI_NO: "Ri Number",
      BANK_NAME: "Bank Name",
      BANK_CITY: "Bank City",
      BANK_COUNTRY: "Bank Country",
      BANK_ADDRESS: "Bank Address",
      BENE_ADDRESS: "Bene Address",
      BANK_REMARK: "Bank Remark",
      BANK_CODE: "BIC / Swift Code",
      IBAN: "IBAN",
      INTER_BANK_NAME: "Intermediate Bank Name",
      INTER_BANK_ACC: "Intermediate Account No",
      INTER_SWIFT_CODE: "Intermediate BIC / Swift Code",
      INTER_IBAN_CODE: "Intermediate IBAN Code",
      BENE_DETAIL_NAME: "Beneficiary Detail Name",
    },
    TYPE: {
      DEPOSIT: "DEPOSIT",
      PAYMENT: "PAYMENT",
    },
  },
  GRN_FORMAT: {
    HEADER: {
      DATE: "Date",
      SUPPLIER: "Supplier",
      SUPPLIER_CODE: "Supplier Code",
      REMARK: "Remark",
      MOBILE: "Mobile No.",
      CONTACT_PERSON: "Contact Person",
      DOC_NO: "Doc No.",
      PHONE_NO: "Phone No.",
      PAYMENT_METHOD: "Payment Method",
      RECEIPT: "Receipt",
      SHARED_SO: "Shared S/O No.",
      COURIER_COMPANY: "Courier Company",
      CONSIGNMENT_NO: "Consignment No.",
    },
    CONTENT: {
      SERIAL_NO: "No.",
      CUSTOMER_MARKING: "Custmer Marking",
      SO_NO: "So No.",
      CTN: "Quantity",
      WEIGHT: "Weight",
      DIMENSION: "Dimension",
      OTHER: "Other",
      PN: "PN",
      TOTAL: "Total",
      CONSIGNMENT_NO: "Consignment No.",
    },
    FOOTER: {
      DELIVER: "Delivery Person's Signature",
      PERSON_IN_CHARGES: "Person In Charge",
      CONTACT_PERSON: "Contact Person",
      CONTACT_NO: "Contact No.",
    },
  },
  PN_FORMAT: {
    HEADER: {
      DATE: "Date",
      SUPPLIER: "Supplier",
      SUPPLIER_CODE: "Supplier Code",
      REMARK: "Remark",
      MOBILE: "Mobile No.",
      CONTACT_PERSON: "Contact Person",
      DOC_NO: "Doc No.",
      PHONE_NO: "Phone No.",
      PAYMENT_METHOD: "Payment Method",
      ACCOUNT_NAME: "Account Name",
      ACCOUNT_NO: "Account No.",
      BANK_ADDRESS: "Bank Branch",
      BANK_NAME: "Bank Name",
    },
    CONTENT: {
      SERIAL_NO: "No.",
      CUSTOMER_MARKING: "Custmer Marking",
      SO_NO: "So No.",
      CTN: "Quantity",
      CURRENCY: "Currency",
      WEIGHT: "Weight",
      DIMENSION: "Dimension",

      TOTAL_AMT: "Order Amount",
      DISCOUNT: "Discount",
      DEPOSIT: "Deposit",
      STICKER_FEE: "Deduct Sticker Fee",
      BALANCE_AMT: "BALANCE AMOUNT",
      TOTAL: "Total",
    },
    FOOTER: {
      DELIVER: "Delivery Person's Signature",
      PERSON_IN_CHARGES: "Person In Charge",
      CONTACT_PERSON: "Contact Person",
      CONTACT_NO: "Contact No.",
    },
  },
  REPORT: {
    COMMON: {
      COL_SERIAL_NO: "No.",
      COL_EFFECTIVE_DATE: "Effective Date",
      COL_DEPOSIT_NO: "Deposit No.",
      COL_CUSTOMER_MARKING: "Marking",

      TOTAL: "Total",
      MAIN_SALESMAN: "Main Salesman",
      SALESMAN: "Salesman",
      DELIVERY_ID: "Delivery Id",
      SO_NO: "S/O No.",
      REPORT_FILTER: "Report Filter",
      FROM_TO: "From {value_from} To {value_to}",
      FROM: "From {value_from}",
      TO: "To {value_to}",
      WAREHOUSE: "Warehouse",
      USER: "User",
      NOTICE_TYPE: "Notice Type",
      CURRENCY: "Currency",
      SHOW_M3: "Show M3?",
      SHOW_AMOUNT: "Show Amount?",
      SHOW_CREDIT_PAYMENT: "Credit Payment?",
      WH_CHARGES_AMT: "W/H Chrg",
      GRAND_TOTAL: "Grand Total",
      REF_NO: "Ref No.",
      LOADED_AMOUNT: "Loaded Amount",
      LOADED_DATE: "Loaded Date",
      BILLING_AMOUNT: "Billing Amount",
      CUST_DEPOSIT: "Cust Deposit",
      MY_PAID: "My Paid",
      FCP_CP: "Fcp/CP",
      SUP_DEPOSIT: "Sup Deposit",
      CASH_PAYMENT: "Cash",
      DELIVERY_DATE: "Delivery Date",
      CUSTOMER_NAME: "Cust. Name",
      COURIER_COMPANY: "Courier Co.",
      REPORT_OPTIONS: "Report Options",
      PARTNER_ID: "Partner Id.",
      SHIPMENT_TYPE: "Shpt. Type",
      SHIPMENT_MODE: "Shpt. Mode",
      HISTORY: "History",
    },
    PACKING_LIST_FORMAT: {
      SERIAL_NO: "S/N",
      SO_NO: "S/O No.",
      SUPPLIER_NAME: "Sup Name",
      T_M3: "T/M3 (T/CM3)<br />总立方 ",
      T_KG: "T/Kg (Vol Weight)<br />总重量",
      T_QTY: "T/Pqty<br />总件数",
      BILL_AMT: "Bill Amt",
      LOADED_AMOUNT: "Loaded Amt",
      CUS_DEPOSIT: "Cus Deposit<br />客付定金",
      MY_PAYMENT: "My P'ment<br />马来付",
      FCP_AMT: "FCP Amount<br />客付定金",
      SUP_DEPOSIT: "Sup Deposit<br />国际付定金",
      LOCAL_PAYMENT: "Local P'ment<br />国际付款",
      WAREHOUSE_CHARGES: "Wh Chrgs<br />仓库费用",
      DISC_AMOUNT: "Disc Amt<br />折扣金额",
      REPORT_TITLE: {
        SUMMARY: "Packing List Summary (B) New",
        DETAIL: "Packing List Details (C) New",
      },

      STOCK_DESC: "Stock Short Desc",
      M3: "M3<br />立方",
      KG: "Kg<br />重量",
      P_QTY: "P Qty<br />件数",
      QUANTITY: "Quantity<br />数量",
      UOM: "Uom<br />单位",
      UNIT_PRICE: "Unit Price<br />单价",
      AMOUNT: "Amount<br />金额",
      RECEIVE_DATE: "Received Date",
      REF_ID: "Ref ID",
      MAIN_SALESMAN: "Main Salesman",
      SALESMAN: "Salesman",
      CUSTOMER_MARKING: "Marking",
      DELIVERY_ID: "Delivery Id",

      REPORT_FILTER: "Report Filter",
      SHOW_M3: "Show M3?",
      SHOW_KG: "Show Kg?",
      SHOW_BILL_AMOUNT: "Show Bill Amount?",
      SHOW_STOCK_DESC1: "Show Stock Desc 1?",
      SHOW_STOCK_DESC2: "Show Stock Desc 2?",
      SHOW_SUPPLIER: "Show Supplier",
      YES: "Yes",
      NO: "No",
      CURRENCY_ID: "Currency ID",
      REMARK: "Remark",
      REMARK2: "Remark 2",
      UNLOAD_AMOUNT: "Unload Amt",
      DEPOSIT_DATE: "D. Date",
      DEPOSIT_NO: "PN #",
      DEPOSIT_RATE: "TR",
      DEPOSIT_AMOUNT: "TS Amt",
      DEPOSIT_CHARGE: "FTC",
      DEPOSIT_CHARGE_MYR: "TC (RM)",
      DEPOSIT_IR: "IR %",
      DEPOSIT_OR: "AOR No.",
      SO_AMOUNT: "SO Amount",
      REF_NO: "Ref No.",
      OTHER_REF_LOADED_AMT: "Loaded Amt",
      OTHER_REF_M3: "M3",
      OTHER_REF_KG: "KG",
      OTHER_REF_CTN: "Ctn",

      SUB_TTL_T_M3: "T/M3",
      SUB_TTL_T_KG: "T/Kg",
      SUB_TTL_T_PQTY: "T/Pqty",
      SUB_TTL_REF: "Ref ",
      SUB_TTL_VOL_WEIGHT: "Vol Weight",
      SUBTOTAL: "SubTotal",
      CURRENCY: "Currency",
      GRANDTOTAL: "Grand Total",
    },
    STOCK_BALANCE_FORMAT: {
      TITLE: "Stock Balance Report with Payment Info",
      DETAIL: "Detail",
      SUMMARY: "Summary",
      SERIAL_NO: "S/N",
      CURRENCY_ID: "Cur ID",
      SO_NO: "S/O No.",
      RECEIVE_DATE: "Rec Date",
      NOTICE_ID: "Notice ID",
      TOTAL_M3: "Total M3",
      TOTAL_PACK: "Total Pack",
      BAL_AMT: "Balance Amount",
      CUS_DEPOSIT: "Cust Deposit",
      MY_PAYMENT: "My Payment",
      SUP_DEPOSIT: "Sup Deposit",
      CASH_PAYMENT: "Cash P'ment",
      CREDIT_PAYMENT: "Credit P'ment",
      FCP_AMOUNT: "FCP Amount",
      PAYABLE_AMT: "Payable Amt",

      PO_DATE: "PO Date",
      STOCK_SHORT: "Stock Short",
      STOCK_DESC: "Stock Desc",
      M3: "M3",
      BAL_PACK: "Bal Pack",
      QUANTITY: "Quantity",
      PURCHASE_PRICE: "Purchase Price",
      AMOUNT: "Amount",
      MAIN_SALESMAN: "Main Salesman",
      SALESMAN: "Salesman",
      CUSTOMER_MARKING: "Marking",
      DELIVERY_ID: "Delivery Id",
      OR_DATE: "O/R Date",
      LOADED_DATE: "Loaded Date",

      // For warehouse summary
      BY_WAREHOUSE_TITLE: "Stock Balance Report By Warehouse",
      COMPANY_GROUP_ID: "C/ID",
      FULL_MARKING: " Msm/Sm/Marking/*Deli ID* (Partner ID)",
      CTN_NO: "Ctn No",
      WH_ID: "W ID",
      RECEIVE_DATE2: "Rec'd Date",
      TOTAL_KG: "Total KG",
      TOTAL_AMOUNT: "Total Amount",
      WAREHOUSE_ID: "Warehouse ID",
      AGENT_ID: "Agent ID",

      // REPORT_FILTER: "All / KCG Only / Exclude KCG",
      FROM: "From",
      TO: "To",
      REPORT_FILTER: "Report Filter",
      REPORT_OPTIONS: "Report Options",
      DELIVERY_ID_TOTAL: "Delivery ID Total",
      MARKING_TOTAL: "Marking Total",
      SALESMAN_TOTAL: "Salesman Total",
      MAIN_SALESMAN_TOTAL: "Main Salesman Total",
      CURRENCY_TOTAL: "Currency Total",
    },
    DO_FORMAT: {
      FORMAT_TITLE: "DELIVERY ORDER",
      TEL_NO: "Tel No.",
      GOODS_RECEIVE_CONDITION: "Goods received in good order & condition",
      SIGNATURE_TITLE: "Authorised Signature & Co Stamp",
      FOOTER_E_DESC: "Computer Generated, no signature required",
      FOOTER_END: "== End ==",

      DONO: "D/Order #",
      REF_ID: "Yr Ref",
      DO_DATE: "Date",
      TRANPORTER: "T-Ref",
      PAGE: "Page",
      MOBILE_NO: "Mobile No.",
      FORWARDER: "Forwarder",
      FAX: "Fax",
      REMARK1: "Remark1",
      REMARK2: "Remark2",
      SERIAL_NO: "S/N",
      SO_NO: "",
      DESCRIPTION: "Description",
      QUANTITY: "Quantity",
      UNIT: "Unit",
      PKG: "Pkg",
      QTY: "Qty",
      TOTAL_M3: "Total M3",
      TOTAL_KG: "Total KG",
      TOTAL_PACKING: "Total Packing",
      SEND_ON_BEHALF: "Send on behalf of",
    },
    RCV_PAYMENT: {
      LBL_REQUEST_AMOUNT: "Request Amount",
      LBL_PN_NO: "PN No.",
      LBL_MARKING: "Marking",
      LBL_STICKER_FEE: "Deduct Sticker Fees",
      LBL_DOC_NO: "Doc No.",
    },
    ORDER_RCV_SUMMARY: {
      REPORT_TITLE: "Order Receiving Summary",

      PACK: "Pack",
      SO_TOTAL_AMOUNT: "S/O Total Amount",
      CUS_DEPOSIT: "Cust Deposit",
      MY_PAID: "My P'ment",
      SUP_DEPOSIT: "Sup Deposit",
      CASH_PAYMENT: "Cash P'ment",
      FCP_AMOUNT: "Fcp Amount",
      CREDIT_PAYMENT: "Credit P'ment",
      BALANCE_AMOUNT: "Bal Amt",
      PN_NO: "PN No.",
      PAID_DATE: "C Paid Date",
    },
    PACKING_LIST_BY_MSM: {
      REPORT_TITLE: "Packing List By Msm",
    },
  },
  MASTER_DATA: {
    DELIVERY_AGENT: {
      MODULE_NAME: "Courier Agent",
      LISTING_TITLE: "Courier Agent Listing",
      CREATE_TITLE: "Create New Courier Agent",
      DETAIL_TITLE: "Courier Agent Detail",
      EDIT_TITLE: "Edit Courier Agent",
      CODE: "Agent Code",
      NAME: "Agent Name",
      LABEL: "Label",
      DELIVERY_ZONE: "Delivery Zone",

      LBL_COURIER: "Courier Service",
      LBL_COURIER_LIST: "Supported Courier",
      LBL_URL_TRACKING: "Tracking URL",
      NORMAL_GOODS_CAPTION: "Normal Goods Caption",
      SENSITIVE_GOODS_CAPTION: "Sensitive Goods Caption",
      COURIER_CHANNEL_NAME_CAPTION: "Courier Channel Name",

      MSG_COUNTRY_COURIER_NOT_SET: "{name} courier not set.",
    },
    SHIPMENT_MODE: {
      LISTING_TITLE: "Shipment Mode Listing",
      CREATE_TITLE: "Create New Shipment Mode",
      DETAIL_TITLE: "Shipment Mode Detail",
      EDIT_TITLE: "Edit Shipment Mode Detail",

      LBL_SHIPMENT_MODE_CODE: "Shipment Mode Code",
      LBL_SHIPMENT_MODE_NAME: "Shipment Mode Name",
      LBL_SHIPMENT_TYPE: "Supported Shipt. Type",
      LBL_QUOTATION_REMARK: "Quotation Remark",
      LBL_QUOTATION_REMINDER: "Quotation Reminder",
      LBL_QUOTATION_DISCLAIMER: "Quotation Disclaimer",
      LBL_SHIPMENT_TERMS: "Shipment Terms",
      LBL_QUOTATION_TERMS_COND: "Quotation Terms Condition",
      LBL_COST_SETUP: "Cost Setup?",
      LBL_SUPPORTED_COUNTRY: "Supported Countries",
      SUPPORTED_COUNTRIES_MSG: "** All Countries supported, field set empty",
      LBL_SHIPMENT_SETTINGS: "Shipt. Settings",

      MODULE_NAME: "Shipment Mode",

      COL_CODE: "Shipment Mode Code",
      COL_NAME: "Shipment Mode Name",
      COL_SHIPMENT_TYPE_NAME: "Shipment Type",

      MODULE_QUOTATION: "Quotation (Default)",
      MODULE_EPO: "EPO (Default)",
      LBL_QUOTATION_SETTINGS: "Quotation Settings",
      APPLY_COST_WITH_DELIVERY_AGENT: "Apply Cost with Courier Agent",
      APPLY_INV_CHARGES_DATE: "Apply Inv Chrg Date",
      LBL_DEFAULT_SELECT: "Default (Customer Portal)",
      LBL_CREATE_IV_BY_PASS_DO: "Create Invoice By Pass D/O",
    },
    COURIER_COMPANY: {
      LISTING_TITLE: "Courier Company Listing",
      CREATE_TITLE: "Create New Courier Company",
      DETAIL_TITLE: "Courier Company Detail",
      EDIT_TITLE: "Edit Courier Company Detail",
      MODULE_NAME: "Courier Company",

      LBL_COURIER_TYPE: "Courier/Logistic",
    },
    PACKING_TYPE: {
      MODULE_NAME: "Packing Type",

      LBL_CODE: "Packing Type Code",
      LBL_NAME: "Packing Type Name",
      LBL_DEFAULT: "Invoice Default",
    },
  },
  PRODUCT_MANAGEMENT: {
    CATEGORY_TYPE: {
      MODULE_NAME: "Category Type",
      LBL_CATEGORY_TYPE_CODE: "Category Type Code",
      LBL_CATEGORY_TYPE_NAME: "Category Type Name",

      LBL_CATEGORY_TYPE_DESCRIPTION: "Category Type Description ",
      BTN_SET_SENSITIVE: "Set Sensitive As Default Wording",

      COL_CATEGORY_TYPE_CODE: "Category Type Code",
      COL_CATEGORY_TYPE_NAME: "Category Type Name",
      COL_USE_FOR_RECEIVING: "Use For EPO/Receiving",
      COL_PRINT_ON_QUOTATION: "Print on Quotation",
      COL_DEFAULT_QUOTE: "Must Quote",
      COL_SPECIAL_CHARGES: "Special Charges",
      COL_PRINT_ON_EPO: "Print On EPO",
      SENSITIVE_TITLE: "Sensitive",
      LBL_MUST_QUOTE: "Must Quote",
      LBL_IS_SENSITIVE: "Is Sensitive?",
      LBL_IS_CAT_DEFAULT: "Product Category Default",

      LBL_QUOTE_WITH_SPECIAL_ADD_CHARGES:
        "Quote with Special Additional Charges",
      LBL_QUOTE_WITH_PRODUCT_CATEGORY: "Quote with Product Category ",
      LBL_PRINT_ON_EPO: "Print On Epo",
      LBL_CATEGORY_TYPE_FORMAT: "EPO Format Type",
      LBL_FORMAT_TYPE_DESCRIPTION: "Format Type Description",
    },
    CATEGORY_PARENT: {
      CREATE_TITLE: "Create New Product Category (Parent)",
      DETAIL_TITLE: "Product Category (Parent) Detail",
      EDIT_TITLE: "Edit Product Category (Parent) Detail",

      LBL_CATEGORY_CODE: "Product Category Code",
      LBL_CATEGORY_NAME: "Product Category Name",
      LBL_CATEGORY_PARENT: "Product Category Parent",

      MODULE_NAME: "Product Category (Parent)",

      COL_CATEGORY_CODE: "Product Category Code",
      COL_CATEGORY_NAME: "Product Category Name",
      COL_CATEGORY_GROUP: "Category Type",
      COL_CATEGORY_PARENT: "Product Category Parent",
      COL_SERVICE_CHARGES: "Service Charges?",
      ROOT_SELECTION: "Parent",
    },
    CATEGORY: {
      LISTING_TITLE: "Product Category (Lvl 2) Listing",
      CREATE_TITLE: "Create New Product Category (Lvl 2)",
      DETAIL_TITLE: "Product Category (Lvl 2) Detail",
      EDIT_TITLE: "Edit Product Category (Lvl 2) Detail",

      LBL_CATEGORY_CODE: "Product Category Code",
      LBL_CATEGORY_NAME: "Product Category Name",
      LBL_CATEGORY_PARENT: "Product Category Parent",
      LBL_INVOICE_DESC: "Invoice Description",
      LBL_CHARGES_FLAT: "Charges?",
      MSG_ASCII:
        "only English letters, numbers, and standard symbols are allowed",
      LBL_MATERIAL: "Material",
      LBL_DEFAULT_UOM: "Default Uom",
      LBL_CATEGORY_TYPE_SHIPMENT_ROUTE: "Set Category Type By Shipment & Route",
      LBL_STOCK_DESC2: "Stock Desc2",

      MODULE_NAME: "Product Category",

      COL_CATEGORY_CODE: "Product Category Code",
      COL_CATEGORY_NAME: "Product Category Name",
      COL_CATEGORY_GROUP: "Category Type",
      COL_CATEGORY_PARENT: "Product Category Parent",
      COL_SERVICE_CHARGES: "Charges?",
      ROOT_SELECTION: "Parent",
      MSG_CATEGORY_DUPLICATION: "{code} is not available.",
      MSG_CATEGORY_SHIPMENT_DUPLICATE:
        'Category Type for "{route}" Route & "{shipment}" Shipment was duplicated.',
    },
    MATERIAL: {
      MODULE_NAME: "Material",
      LBL_MATERIAL_CODE: "Material Code",
      LBL_MATERIAL_NAME: "Material Name",
    },
  },
  PN_PAYMENT: {
    MODULE_NAME: "PN Payment",
    LBL_BADGE_NO: "Badge No.",
    LBL_DATE: "Payment Date",

    SO_TITLE: "S/O Detail(s)",
    BENE_TITLE: "Bene/Bank Detail",

    SHOW_PAYABLE_DETAILS: "Show PN Detail",
    SHOW_SO_BENE: "Show S/O Bene & Account Detail",

    LBL_DUE_DAYS: "Due Day(s)",
    LBL_SUPPLIER: "Supplier",

    COL_SUPPLIER_DEPOSIT: "S/O Sup Deposit",
    COL_CUSTOMER_DEPOSIT: "S/O Cus Deposit",
    COL_CASH_PAYMENT: "Cash Payment",
    COL_WAREHOUSE_DISCOUNT: "Sup Wh Disc",
    COL_DISCOUNT: "Disc. Amt",
    COL_MY_PAID: "My Paid",
    COL_STICKER_FEES: "Sticker Fees",
    COL_STICKER_FEES_PAID_AMOUNT: "Sup Pay Amt",
    COL_PAYABLE_AMOUNT: "PN Amt",
    COL_PAID_AMOUNT: "Paid PN Amt",
    COL_PN_CANCEL_AMOUNT: "PN Cancel Amt",
    COL_BALANCE_PN_AMOUNT: "Bal. PN. Amt.",
    COL_PN_PAYMENT_AMOUNT: "PN Payment Amt.",
    COL_BANK_ACC_NAME: "Acc. Holder",
    COL_BANK_ACC: "Acc No.",
    COL_BANK_NAME: "Bank Name",
    COL_BANK_PROVINCE: "Bank Province",
    COL_BANK_DISTRICT: "Bank District",
    COL_BANK_ADDRESS: "Bank Address",
    COL_PN_REF_NO: "PN Ref No.",

    APPROVE_SUMMARY: "PN Payment Summary",
    MODULE_NAME_APPROVE: "Approve PN Payment",
    MODULE_NAME_ACKNOWLEDGE: "Acknowledge PN Payment",

    PN_PAYMENT_DETAIL_TITLE: "PN Payment Detail",
    APPROVE_PN_CONFIRMATION:
      "You area not allow to edit this Badge No.: {badge_no} after approved. ",
  },
  BANK_BENE: {
    LBL_ACCOUNT_NAME: "Bank Account Name",
    LBL_ACCOUNT_NO: "Bank Account No.",
    LBL_BENE_CONTACT_CALLING_CODE: "Bene Contact Calling Code",
    LBL_BENE_CONTACT_NO: "Bene Contact No.",
    LBL_BENE_CONTACT_PIC: "Bene Contact Pic",
    LBL_BENE_ADDRESS: "Bene Address",

    LBL_SAVE_AS_NEW_BANK: "Save As New Bene",

    LBL_BANK_NAME: "Bank Name",
    LBL_BANK_COUNTRY: "Bank Country",

    LBL_BANK_PROVINCE: "Bank Province",
    LBL_BANK_DISTRICT: "Bank District",

    LBL_BANK_ADDRESS: "Bank Address",
    LBL_BANK_RI_NO: "Ri No.",
    LBL_BANK_SWIFT_CODE: "Swift Code",
    LBL_BANK_IBAN: "Iban Code",

    LBL_INTER_BANK_NAME: "Intermediate Bank Name",
    LBL_INTER_BANK_ACCOUNT_NO: "Intermediate Acc No.",
    LBL_INTER_SWIFT_CODE: "Intermediate Swift Code",
    LBL_INTER_IBAN_CODE: "Intermediate IBAN Code",

    LBL_INTER_ENABLE: "Intermediate Bank ?",

    BANK_MODAL_TITLE: "Bank List",
  },
  SO: {
    COL_SUPPLIER_DEPOSIT: "Sup Deposit/DCP",
    COL_CUSTOMER_DEPOSIT: "Cus Deposit",
    COL_DEPOSIT: "DCP Deposit",
    COL_CASH_PAYMENT: "Cash Payment",
    COL_WAREHOUSE_DISCOUNT: "Sup Wh Disc",
    COL_DISCOUNT: "Disc. Amt",
    COL_MY_PAID: "My Paid",
    COL_STICKER_FEES: "Sticker Fees",
    COL_STICKER_FEES_PAID_AMOUNT: "Sup Pay Amt",
    COL_FCP_AMOUNT: "Fcp/CP TT",
    COL_CREDIT_AMOUNT: "Credit Amt",
    COL_SO_PAID_AMOUNT: "S/O Paid Amt",
    COL_CURRENCY_RATE: "Currency Rate",
    COL_GET_CN_AMOUNT: "Get CN Amt",
    COL_BALANCE_AMOUNT: "FCP/PN Amt.",
    COL_BLOCK_TT: "Blocked TT",
    COL_CN_TT: "CN Amt",
    COL_OUTSTANDING_AMOUNT: "OutStanding Amt",
    COL_BLOCK_AMOUNT: "Block Amt",
    COL_CN_AMOUNT: "CN Amt",
    COL_CONVERSION_FACTOR: "Currency Factor",
    COL_CN_LOCAL_AMOUNT: "CN Local Amt",
    COL_DN_LOCAL_AMOUNT: "DN Local Amt",

    COL_DN_AMOUNT: "DN Amt",
    COL_INV_AMOUNT: "Inv Amt",
    COL_SO_REV: "S/O Recv?",
    COL_CLOSE_AMOUNT: "Close Amt",
  },
  PAYMENT_INSTRUCTION: {
    MSG_SO_FULLY_CANCELLED: "This S/O has cancelled the whole so amount",
    MSG_NO_INSTRUC_STATUS_RECORD:
      "{ref_no}: No records that under {instruc_status} instruction status found",
    MSG_SO_NOT_FOUND:
      "Payment instruction record for S/O No. ({so_no}) not found",
    MSG_REFRESH_PAGE:
      "Data for following S/O No. ({so_no}) has been changed. You are not allowed to {action} these records. Please refresh the page.",
    MSG_PAID_SO:
      "Following S/O No. ({so_no}) already made payment. You are not allowed to {action} these records.",
  },
  INV_FORMAT: {
    SERIAL_NO: "S/N",
    ITEM_DESCRIPTION: "Description",
    QUANTITY: "Quantity",
    UNIT: "Unit",
    PRICE: "Price",
    DISC: "Disc",
    AMOUNT: "Amount",
    INVOICE_TITLE: "Invoice",
    DELIVER_TO: "Deliver To",
    INVOICE_NO: "Invoice No.",
    YR_REF: "Yr Ref",
    DATE: "Date",
    TERMS: "Terms",
    TTL_PACKING: "Total Packing",
    PAGE: "Page",
    INVOICE_TERMS:
      "Accounts not paid within terms are subject to a monthly overdue charge until the balance is fully paid.",
    COMPUTER_GENERATOR: "Computer generated, no signature required",
    BANK_ACCOUNT_TITLE: "* Our Bank Account",
  },
  USER_PROFILE: {
    PROFILE_TITLE: "User Profile",
    CHANGE_PASS: "Change Password",
    VERIFY_PASS: "Verify Password",
    VERIFY_DESC: "Your Password Again",
    PASS_NOT_MATCH: "Password Not Match",
    CURR_PASS_ERR: "Current Password Is Wrong",
    CURRENT_PASSWORD: "Current passowrd",
    NEW_PASS: "New password",
    FORGOT_BUTTON: "Forgot Password",
  },
  USER_N_ROLE_MANAGEMENT: {
    USER: {
      LISTING_TITLE: "User Listing",
      CREATE_TITLE: "Create New User",
      DETAIL_TITLE: "User Detail",
      EDIT_TITLE: "Edit User Detail",
      RESET_LOGIN: "RESET LOGIN",
      SENT_EMAIL: "Send Email",
      NEW_PASS: "New password",
      RESET_PASS: "Change Password",
      LBL_USER_NAME: "Name",
      LBL_USER_USERNAME: "Username",
      LBL_USER_EMAIL: "Email",
      LBL_USER_PASSWORD: "Password",
      LBL_USER_ROLE: "Roles",
      LBL_USER_DATA_FILTER: "Data Filter (s)",
      LBL_USER_IGNORE_FILTER: "Ignore Filter",
      LBL_DEPARTMENT: "Department",
      LBL_IGNORE_FILTER_ONLY: "Ignore Data Filter Only",
      LBL_USER_TYPE: "User Type",
      LBL_USER_GROUP: "User Group",

      MODULE_NAME: "User",

      COL_USERNAME: "Username",
      COL_NAME: "Name",
      COL_ROLES: "ROLES",
      COL_DATA_FILTER: "Data Filter (s)",
      COL_IGNORE_FILTER: "Ignore Data Filter",
      COL_DEPARTMENT: "Department",
      COL_USER_TYPE: "User Type",
      USER_TYPE: {
        WAREHOUSE_STAFF: "仓库/办公室人员",
        AGENT_STAFF: "代理人员",
      },
      COL_LAST_LOGIN: "Last Login",
    },
    ROLE: {
      LISTING_TITLE: "Role Listing",
      CREATE_TITLE: "Create New Role",
      DETAIL_TITLE: "Role Detail",
      EDIT_TITLE: "Edit Role Detail",

      LBL_ROLE_NAME: "Role Name",
      LBL_ROLE_DESCRIPTION: "Role Description",
      LBL_ROLE_PERMISSION_PRIVILEGE: "Permission & Privilege",
      LBL_ROLE_PERMISSION: "Role Permission",
      LBL_DEFAULT_SORT: "Default Sort",
      LBL_SORT_ALPHABET: "Sort by Alphabet",
      LBL_SEARCH_PERMISSION: "Search Role Permission",
      LBL_ALL_PERMISSION: "All Permission",
      LBL_APPLY_TO: "Apply For",

      MODULE_NAME: "Role",

      COL_NAME: "Role Name",
      COL_DESCRIPTION: "Role Description",
      COL_APPLY_TO: "Apply For",

      WARNING_DUPLICATE:
        "Reminder: Data exists in this record - {exist_record} <br /> The system will not allow you to save the same data record twice.",
      BTN_SORT_MENU: "Sort Follow Menu",
      BTN_SORT_ALPHABET: "Sort By Alphabet",
      MSG_BLOCK_EDIT_CREATE_ROLE: "For {staff_type} roles exists.",
    },
    DATA_FILTER: {
      LISTING_TITLE: "Data Filter Listing",
      CREATE_TITLE: "Create New Data Filter",
      DETAIL_TITLE: "Data Filter Detail",
      EDIT_TITLE: "Edit Data Filter Detail",

      LBL_DATA_FILTER_NAME: "Name",
      LBL_DATA_FILTER_DESCRIPTION: "Description",
      LBL_DATA_FILTER_COMPANY: "Company",
      LBL_DATA_FILTER_WAREHOUSE: "Warehouse",
      LBL_DATA_FILTER_MSM: "Main Salesman",
      LBL_DATA_FILTER_SM: "Salesman",
      LBL_DATA_FILTER_MARKING: "Marking",
      LBL_DATA_FILTER_PERMISSION_PRIVILEGE: "Permission & Privilege",
      LBL_INCLUDE: "include",
      LBL_EXCLUDE: "exclude",

      MODULE_NAME: "Data Filter",

      COL_NAME: "Data Filter Name",
      COL_DESCRIPTION: "Data Filter Description",
    },
    USER_GROUP: {
      CREATE_TITLE: "Create New User Group",
      DETAIL_TITLE: "User Group Detail",
      EDIT_TITLE: "Edit User Group",
      MODULE_NAME: "User Group",

      LBL_GROUP_CODE: "Group Code",
      LBL_GROUP_NAME: "Group Name",
      LBL_SPECIAL_RIGHTS: "Special Rights",
      LBL_SEARCH_SPECIAL_RIGHTS: "Search Special Rights",
    },
  },
  WMS: {
    MISSING_STATUS_INQUIRY: {
      LISTING_TITLE: "Assign Missing S/O",
      MODULE_NAME: "Assign Missing S/O",
      SHARED_SO: "Shared S/O No",
      SHARED_SO_TITLE: "Shared S/O",
      COL_COMPLETE_STATUS_INQUIRY: "Is Complete",
      COURIER_COMPANY_NAME: "Courier Company Name",
      LBL_COURIER_COMPANY: "Courier Company",
      CONSIGNMENT_NOTE_NO: "Consignment Note No",
      WAREHOUSE_LOCATION: "Warehouse Location",
      FILL_IN_STATUS_INQUIRY: "Assign S/O",
      FILL_IN_STATUS_INQUIRY_TITLE: "Assign S/O",
      NOT_SAME_AS_EPO: "{name} Not same as EPO",
      FILL_IN_STATUS_INQUIRY_SUCCESS: "Successfully Assign Missing S/O",
      STATUS_INQUIRY_TYPE: "Status Inquiry Type",
      COURIER_STATUS_INQUIRY: "Courier Status Inquiry",
      STATUS_INQUIRY: "Status Inquiry",
      MSG: {
        SEARCH_MISSING_SO_FAILED: "Search for missing S/O failed",
        UPDATE_DETAILS_CONFIRMATION:
          "The selected details are not same as the S/O No. Are you sure to change it?",
        SPECIAL_INS_FAILED: "Fail to get special instruction.",
      },
      CONFIRMATION_CONTINUE_RECEIVE:
        "Epo: {epo_no} request to stop receive.<br />Are You Sure to continue receiving?",
      INSTRUCTION_BY_MARKING: "Instruction By Marking",
      INSTRUCTION_BY_SO: "Instruction By SO",
      ARRANGED_SO: "Arranged S/O",
      EXCLUDE_ARRANGED_SO: "Exclude Arranged S/O",
      LBL_ASSIGNED_STATUS: "Assigned Status",
      ASSIGNED_STATUS: {
        NOT_ASSIGNED: "Not Assigned",
        ASSIGNED: "Assigned",
      },
      NO_MARKING: "No Marking",
      LBL_AUTO_SAVE_CONSIGNMENT_SO: "Save Consignment S/O",
      MSG_NOT_SAME_DETAILS: "{name} different then entered",
    },
    DUPLICATE_SO: {
      SUPPLIER_NAME: "Supplier Name",
      RECEIVED_DATE: "Received Date",
      SHARED_SO: "Shared S/O No.",
      CONFIRMATION_DUPLICATE_SO_NO:
        "Inbound with same So No exists.<br />Are You Sure to continue receiving?",
      MSG: {
        DUPLICATE_SO_NO: "Duplicate S/O No.",
      },
    },
    VERSION: "Version",
    CTN: "CTN",
  },
  SETTINGS: {
    LANGUAGE: {
      CREATE_TITLE: "Create New Language",
      LISTING_TITLE: "Language Listing",
      DETAIL_TITLE: "Language Detail",
      EDIT_TITLE: "Edit Language",
      MODULE_NAME: "Language",
      LBL_CODE: "Language Code",
      LBL_NAME: "Language Name",
      LBL_LOCALE: "Locale",
      LBL_SUPPORT_AT: "Support At",
      LBL_SORT_ORDER: "Sort Order",
      LBL_IMAGE: "Image",

      COL_CODE: "Language Code",
      COL_NAME: "Language Name",
      COL_SUPPORT_AT: "Support At",
      COL_SORT_ORDER: "Sequence",
      COL_FLAG: "Flag",
    },
    WAREHOUSE_SETTINGS: {
      LISTING_TITLE: "Warehouse Settings Summary",
      DETAIL_TITLE: "{warehouse_name} Warehouse Settings",
      GIMWORLD_SETTINGS: "GIM WORLD ORDER",
      MANIFEST_CONSIGNMENT_SETTING: "MANIFEST CONSIGNMENT SETTING",
      LBL_MANIFEST_ADDRESS: "Manifest Address",
      LBL_MANIFEST_CONTACT: "Manifest Contact No.",
      LBL_MANIFEST_NAME: "Manifest Name",
      GRN_FORMAT_SETTINGS: "GRN Format Settings",
      PN_FORMAT_SETTINGS: "PN Format Settings",
      MODULE_NAME: "Warehouse Settings",
      PREVIEW_GRN_FORMAT: "Preview GRN Format",

      LBL_WAREHOUSE: "Warehouse",
      LBL_CONTACT: "Contact Person",
      LBL_COMPANY: "Supported Company",
      LBL_COMPANY_SUBGRP: "Supported Company Sub Group",
      LBL_QUOTATION_DESC: "Quotation Desc",

      LBL_GOODS_RECEIPT_PAYABLE_STICKER_FEE_CURRENCY:
        "Goods Received/Payable Note Sticker Fee Currency",
      LBL_GOODS_RECEIPT_PAYABLE_STICKER_FEE:
        "Goods Received/Payable Note Sticker Fee",
      LBL_QUOTE_AREA: "Replace {area} with State & City",
      LBL_WAREHOUSE_NAME_PRINT_IN_EPO: "Warehouse Name Print on EPO",
      LBL_FORWARDER: "Forwarder",
      LBL_FORWARDER_COUNTRY_ID: "Forwarder Country ID",
      LBL_FORWARDER_STATE_ID: "Forwarder State ID",
      LBL_GENERAL_SETTING: "General Settings",

      LBL_GIMWORLD_ORDER_CATEGORY: "Default Category",
      LBL_SERVICE_CHARGES: "Default Service Charges",
      LBL_GIMWORLD_ORDER_CURRENCY: "Default Currency",
      LBL_GIMWORLD_ORDER_LOCATION: "Drop At",
      LBL_GIMWORLD_SUPPLIER: "Supplier",

      LBL_TT_CURRENCIES: "TT Currencies",
      LBL_DEFAULT_TT_CURRENCY: "Default TT Currency",
      LBL_BLOCK_CREATE_EPO: "Block Create EPO",

      GRN_FORMAT: {
        LBL_GRN_FORMAT: "GRN Format",
        LBL_GRN_LANGUAGE: "Language",
        LBL_COMPANY_HEADER_TITLE: "Company Title",
        LBL_GRN_TITLE: "GRN Title",
        LBL_COMPANY_ADDRESS_CONTACT: "Company Address & Contact No.",
        LBL_COMPANY_ADDRESS_CONTACT_RECEIPT:
          "Company Address & Contact No. (Receipt)",
        LBL_GRN_REMARK: "GRN Remark",
        LBL_GRN_FOOTER_REMARK: "GRN Footer Remark",
        LBL_PRINT_GRN_FOOTER: "Print On Receipt Paper",

        LBL_PIC: "GRN Contact Persion",
        LBL_CALLING_CODE: "GRN Contact Calling Code",
        LBL_CONTACT: "GRN Contact No.",
      },

      PN_FORMAT: {
        LBL_COMPANY_HEADER_TITLE: "Company Title",
        LBL_COMPANY_ADDRESS_CONTACT: "Company Address & Contact No.",

        LBL_PIC: "PN Contact Persion",
        LBL_CALLING_CODE: "PN Contact Calling Code",
        LBL_CONTACT: "PN Contact No.",
      },

      COL_PIC: "Person In Charge",
      COL_CONTACT_NUMBER: "Contact Number",
      COL_WECHAT_ID: "WeChat ID",
      COL_IS_DEFAULT: "Default",
      COL_IS_SHOW: "Show",
      COL_REMARK: "Remark",
      COL_CONTACT_CALLING_CODE: "Contact Number Calling Code",
      COL_GIMWORLD_ORDER_CATEGORY: "GimWorld Order Default Category",

      LBL_EPO_WAREHOUSE_CONTACT_REMARK: "EPO Warehouse Contact Remark",

      COL_SUPPORTED_COM: "Supported Company",
      COL_STICKER_FEE: "Sticker Fee",

      TAB_TITLE: {
        GENERAL: "General",
        ORDER_RECEIVE: "Order Receive",
        QUOTATION_EPO: "Quotation & Epo",
      },

      MSG_COMPANY_CODE_NOT_SET: "Company Record not found",
    },
    SYS_NOTIFICATION: {
      MODULE_NAME: "System Notification Settings",

      LBL_SYS_MODULE_NAME: "Module Name",
      LBL_VIA_EMAIL: "Via Email",
      LBL_SYSTEM_INBOX: "System Inbox",
      LBL_SENT_TO: "Sent To",
      LBL_EMAIL_SUBJECT: "Email Subject",
      LBL_SYSTEM_INBOX_TITLE: "System Inbox Title",
      LBL_SYSTEM_INBOX_CONTENT: "System Inbox Content",
      LBL_EMAIL_CONTENT: "Email Content",

      LBL_EMAIL_DESCRIPTION:
        "For Example: example@gmail.com;example1@gmail.com",

      MSG_EMAIL_REQUIRED: "Recipient required either: Sent To or Email",
    },
    AGENT: {
      MODULE_NAME: "Gbizs Agent",
      NAME: "Agent Code",
      API_URL: "Api Url",
    },
  },
  TRANSACTION: {
    CONSIGNMENT_SO: {
      MODULE_NAME: "Consignment S/O",
      SO_STATUS_DESC:
        "S/O for the consignment details is still awaiting confirmation from the customer; you may indicate it as pending.",
      EPO_SELECTION_TITLE: "EPO Selection",
      DETAILS_TITLE: "Consignment Detail(s)",
      DETAILS_TITLE_SO: "{so_no} Consignment Detail(s)",
      STATUS_INQ_MATCHED:
        "Found S/O No.: {so_no} has been received multiple time, please select a specific entry.",

      LBL_TTL_RCV: "Ttl Rcv?",
      LBL_FULLY_RCV: "Fully Rcv?",
      LBL_ARRANGE_SO: "Arranged S/O?",
      LBL_SO_STATUS: "S/O Status",
      LBL_SUPPLIER: "Supplier",
      LBL_ORDER_IMAGE: "Upload S/O by",
      LBL_GRN_NO: "GRN No.",
      LBL_OTHER_COURIER_COMPANY: "Other Courier Company",
      LBL_RECEIVED_CTN: "Received CTN",
      LBL_COURIER: "Courier?",
      LBL_SHARED_SO: "Shared S/O?",

      BTN_VIEW_DETAIL: "View Detail",
      BTN_ADD_EPO: "Add From EPO",
      BTN_ADD_SUPPLIER: "Add New Customer's Supplier",

      MSG_NO_EPO_SELECT: "Please select a EPO",

      COL_COURIER_COMPANY: "Courier Company",
      COL_CONSIGNMENT_NOTE_NO: "Consignment No.",
      COL_COURIER_LOGISTIC: "Courier/Logistic",
      COL_ATTACHMENT: "Attachment",
      COL_IS_DELETED: "Is deleted",

      MSG_CONSIGNMENT_NO:
        "The consignment ({consignment_no}) appears to be duplicated with another S/O. Are you sure to continue?",
      MSG_CONSIGNMENT_AUTO_SAVE:
        "The consignment {consignment_no} has undergone a status inquiry and has matched successfully. Would you like to save this information?",
      MSG_SO_NO_DUPLICATE_SHARE_SO: "Entered Shared S/O duplicate with S/O No.",
      MSG_SHARED_SO_DUPLICATE:
        "Entered Shared S/O No. duplicate with other Shared S/O No.",
      MSG_INBOUND_EXISTS: "Status inquiry exists.",
    },
    QUOTATION: {
      SEND_EMAIL: "Send Quotation By Email",
      MSG: {
        QUOTATION_CONTENT_UNDEFINED: "Quotation Content missing.",
        EMAIL_SENT: "{quotation_no} quotation was sent to the customer",
        EMAIL_SENT_FAIL: "{quotation_no} quotation failed send to the customer",
      },
    },
  },
  SEND_EMAIL: {
    LBL_TO: "To",
    LBL_CC: "CC",
    LBL_BCC: "BCC",
    LBL_SUBJECT: "Subject",
    LBL_CONTENT: "Content",
  },
  SCAN_DEVICE: {
    MSG_FAILED_INIT_SCAN_DEVICE: "❌ Scanner initialization failed.",
    MSG_CAMERA_NOT_DETECT:
      "Camera not detected; please check device permissions.",
    MSG_DEVICE_PERMISSION:
      "Camera permission denied; please allow camera access in browser settings.",
    MSG_DEVICE_NOT_FOUND:
      "Camera device not found; please check the connection.",
    MSG_SCAN_ERROR: "Failed to start the camera: {error_msg}",
    MSG_UNKNOW_ERROR: "Unknown error",
    MSG_SCANNING_PROGRESS: "⚠️ Scan in progress.",
    MSG_NOT_READABLE: "The camera is being used by another application.",
    MSG_CAMERA_OVER_CONSTRAINED:
      "Camera configuration does not meet the requirements.",
    MSG_TIMEOUT: "Camera startup timed out; please try again.",
    MSG_OUT_OF_MEMORY:
      "Insufficient device memory; please close other apps and try again.",
    MSG_MAX_RECOVERY:
      "Multiple attempts have failed; please restart your browser.",
    MSG_START_UP_FAILED: "Startup failed",
    MSG_FAILED_START_UP_RESTART:
      "The camera failed to start; please scan the QR code or restart your browser.",
    MSG_DECODE_FAILED: "Decoding failed",
    MSG_INVALID_IMAGE:
      "Please ensure the image contains a valid QR code or barcode.",
    MSG_PERMISSION_REQUIRED: "Camera permission required",
    MSG_AUTHORIZE_CAMERA: 'Tap "Authorize" to allow access to the camera.',
    MSG_INITIALIZING_CAMERA: "Initializing Camera",

    BTN_AUTHORIZE: "Authorize",
  },
};
